import { lccstate, registry } from 'lcc-state';
import { resize } from '@dojo/framework/core/middleware/resize';
import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import { ActiveView } from '@holmescorp/explore-view';
import { cssProperty } from '@holmescorp/middleware/css-property';
import { TocSlidePane } from '@holmescorp/table-of-contents';
import css from '../css/content.m.css';
registry.define('ActiveView', ActiveView);
registry.define('TocSlidePane', TocSlidePane);
const factory = create({ theme, lccstate, cssProperty, resize }).properties();
export const Content = factory(({ properties, middleware: { theme, cssProperty, resize } }) => {
    const { showNoSession = false } = properties();
    const rect = resize.get('content-main');
    if (rect) {
        const { width } = rect;
        const margins = width > 1295 ? 0 : 15;
        const contentwidth = Math.max(Math.min(width, 1280), 375) - margins;
        cssProperty.set('content-main', '--lcc-content-width', `${contentwidth}px`);
    }
    const themeCss = theme.classes(css);
    const kids = (() => {
        return [
            w('PageGroup', {
                kids: [
                    { widget: 'Widget', realwidget: 'TocSlidePane', name: 'toc-slide-pane' },
                    { widget: 'Widget', realwidget: 'ActiveView', name: 'active-view' }
                ]
            })
        ];
    })();
    const noSession = [
        v('div', { classes: [themeCss.noSession], xqa: 'no-session-warning' }, [
            v('p', {}, [
                'You have reached this page in error. Please click the link below to select the correct product for your studies.'
            ]),
            v('p', { xqa: 'no-session-link' }, [v('a', { href: '/am/@@welcome' }, ['Choose Product'])])
        ])
    ];
    return v('main', { id: 'content-main', key: 'content-main', role: 'main', classes: [theme.variant(), themeCss.root] }, showNoSession ? noSession : kids);
});
